export default {
  namespaced: true,
  state: {
    rtcClient: null,
    localUser: {
      peerId: null,
      stream: null
    },
    peerError: null,
    isShareScreenOn: false,
    chimeShareScreenDidStop: false,
    deviceRtcError: false,
    virtualBgModel: null,
    virtualBg: 'none',
    activeAudioTrack: null,
    audioOnly: false
  },
  getters: {
    /**
     * Check if media devices is invalid
     *
     * @return boolean
     */
    isMediaInvalid: state => {
      if (state.peerError) {
        return state.peerError.msg === 'OverconstrainedError';
      }
      return false;
    },

    /**
     * Agora uid conflict
     */
    isUidConflict: state => {
      if (state.peerError) {
        const msg = state.peerError;
        return (msg.code && msg.code == 'UID_CONFLICT');
      }
      return false;
    },

    /**
     * UID BANNED - Simultaneous Connection
     */
    isUidBanned: state => {
      return state.peerError?.code === 'UID_BANNED';
    }
  },
  mutations: {
    setRtcClient(state, data) {
      state.rtcClient = data;
    },
    setLocalUserStream(state, data) {
      state.localUser.peerId = data.peerId || state.localUser.peerId;
      state.localUser.stream = data.stream || state.localUser.stream;
    },
    setPeerError(state, data) {
      state.peerError = data;
    },
    setIsShareScreenOn(state, data) {
      state.isShareScreenOn = data;
    },
    setDeviceRtcError(state, data) {
      state.disconnectRtc = data;
    },
    setVirtualBg(state, data) {
      state.virtualBg = data;
    },
    setVirtualBgModel(state, data) {
      state.virtualBgModel = data;
    },
    setActiveAudioTrack(state, data) {
      state.activeAudioTrack = data;
    },
    setAudioOnly(state, data) {
      state.audioOnly = data;
    },
    setChimeShareScreenDidStop(state, data) {
      state.chimeShareScreenDidStop = data;
    }
  },
  actions: {
    /**
     * Updated Local Stream
     *
     * @param {commit} commit
     * @return void
     */
    updateLocalStream({ commit }, rtc) {
      if (!rtc.hasOwnProperty('error')) {
        commit('setLocalUserStream', rtc);
        commit('setPeerError', null);
      } else {
        commit('setPeerError', rtc.error);
        commit('setDeviceRtcError', true);
      }
    }
  }
};
